<template>
    <MainContentSearchable title="Listado de usuarios" id="taquilleros" v-model="filters" :meta="loading ? {} : taquilleros.meta" @updated="debouncedGetTaquilleros">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de usuarios</h3>
            <div class="card-tools mb-3">
                <router-link :to="{ name: 'back.taquilleros.crear' }" class="btn btn-primary">
                    CREAR USUARIO
                </router-link>
            </div>
        </template>

        <template v-slot:content v-if="!loading && taquilleros">
            <div :class="['table', { 'expanded': taquilleros.data.length <= 3 }]">
                <b-table hover :items="taquilleros.data" :fields="fields">
                    <template #cell(rol)="{ item }">
                        {{ item.role }}
                    </template>
                    <template #cell(id)="{ item, index }">
                        <OpcionesDropdownTableComponent                 
                            :lastIndex="taquilleros.data.length > 3 && index >= taquilleros.data.length - 3"
                            :options="[
                                { to: { name: 'back.taquilleros.show', params: { taquillero_id: item.id, role: item.role }}, label: 'Detalles'},
                                { to: { name: 'back.taquilleros.editar', params: { taquillero_id: item.id, role: item.role }}, label: 'Editar'},
                                item.role !== 'Manager' ? { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'} : {},
                            ]"
                        />
                        <BorrarTaquillero v-if="item.role !== 'Manager'" :taquillero="item" v-on:close="closeModal"/>
                    </template>
                </b-table>
            </div>
        </template>
    </MainContentSearchable>

</template>

<script>
    import BorrarTaquillero from './modals/BorrarTaquillero';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';

    export default {
        data() {
            return {
                taquilleros: { meta: { current_page: 1 } },
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [ 'nombre', 'email', 'rol', { key: 'id', label: 'opciones', class: 'text-center' }]
            }
        },
        created() {
            this.getTaquilleros();
            this.debouncedGetTaquilleros = _.debounce(this.getTaquilleros, 500)
        },
        methods: {
            getTaquilleros : function() {
                const params = {
                    filters : this.filters
                };

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.index'), params).then(res => {
                    this.taquilleros = res.data;
                });
            },
            setPage(page) {
                this.filters.page = page;
                this.getTaquilleros();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getTaquilleros();
                }
            },
        },
        components: {
            OpcionesDropdownTableComponent, MainContentSearchable, BorrarTaquillero
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>
